

import Vue from "vue";

import CSV from "@/components/templates/CSV.vue";
import CopyButton from "@/components/templates/CopyButton.vue";
import Top from "@/components/templates/Top.vue";
import IntegrationDetail from "./IntegrationDetail.vue";

import { mapActions, mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import * as views from "@/plugins/utils/View";
import * as crud from "@/plugins/utils/Crud";
import * as action from "@/store/actions";
import { Integration, View } from "@/types/conf";


export default Vue.extend({
  name: "Integration",
  data: () => ({
    canDelete: false,
    canCreate: false,
    canUpdate: false,

    computedItems: screen.width < 600 ? 3 : 10,
    computedHeight: screen.width < 600 ? 48 * 12.2 : 48 * 11,

    alertType: "",
    alertMessage: "",
    integrationList: [] as Integration[],
    selectedItem: null as Integration | null,
    search: "",
    dialog: false,
    dialogDelete: false,
    loadingList: false,
  }),
  computed: {
    ...mapGetters({
      views: "auth/views",
      hoverColor: "lookAndFeel/hoverColor",
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
    }),
  },
  async mounted() {
    this.loadingList = true;
    this.integrationList = await this.getIntegrationList(
      action.INTEGRATION_CONTROLLER
    );
    this.actionHandler();
    this.loadingList = false;
  },
  components: {
    CSV,
    CopyButton,
    Top,
    IntegrationDetail
},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions({
      getIntegrationList: "crudService/getList",
      deleteIntegration: "crudService/deleteObject",
    }),
    headers() {
      return [
        {
          text: i18n.t("misc.actions"),
          value: "actions",
          sortable: false,
          align: "left",
        },
        {
          text: i18n.t("misc.name"),
          align: "start",
          value: "name",
        },
        {
          text: i18n.t("integration.type"),
          align: "start",
          value: "type",
        },
        {
          text: i18n.t("integration.hostName"),
          align: "start",
          value: "host",
        },
        
      ];
    },
    actionHandler() {
      const view = this.views.find((v: View) => v.name == views.INTEGRATION);
      if (view) {
        this.canDelete = view.actions.includes(crud.DELETE);
        this.canCreate = view.actions.includes(crud.CREATE);
        this.canUpdate = view.actions.includes(crud.UPDATE);
      }
    },

    deleteItem(item: Integration) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const response = await this.deleteIntegration({
        action: action.INTEGRATION_CONTROLLER,
        id: this.selectedItem?.id,
      });
      this.closeDelete();
      if (response) {
        this.alertType = "green darken-1";
        this.alertMessage = ((i18n.t("misc.deleted") as string) +
          i18n.t("misc.defaultSuccess")) as string;
        let itemListUpdated = [...this.integrationList];
        this.integrationList = itemListUpdated.filter(
          (exten) => exten.id != this.selectedItem?.id
        );
      } else {
        this.alertType = "error";
        this.alertMessage = i18n.t("misc.defaultError") as string;
      }
      this.$store.dispatch("snackbar/showSnack", {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    
    async refreshList() {
      this.loadingList = true;
      this.integrationList = await this.getIntegrationList(
        action.INTEGRATION_CONTROLLER
      );
      this.actionHandler();
      this.loadingList = false;
    },
  },
});
